import { render, staticRenderFns } from "./workcenter.vue?vue&type=template&id=fb6634e4&scoped=true&"
import script from "./workcenter.vue?vue&type=script&lang=js&"
export * from "./workcenter.vue?vue&type=script&lang=js&"
import style0 from "./workcenter.vue?vue&type=style&index=0&id=fb6634e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6634e4",
  null
  
)

export default component.exports